
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import fr from './locales/fr';
import en from './locales/en';
import ar from './locales/ar';

// Configuration des ressources de traduction
const resources = {
  fr,
  en,
  ar,
};

// Fonction pour appliquer les attributs DOM (Direction et Langue)
const applyDomAttributes = (lng: string) => {
  if (!lng) return;
  const cleanLng = lng.split('-')[0]; // Nettoyage (ex: fr-FR -> fr)
  const isArabic = cleanLng === 'ar';
  
  document.documentElement.setAttribute('lang', cleanLng);
  document.documentElement.setAttribute('dir', isArabic ? 'rtl' : 'ltr');

  if (isArabic) {
      document.documentElement.classList.add('rtl');
      document.body?.classList.add('rtl');
      const fontRule = "'Tajawal', sans-serif";
      document.documentElement.style.setProperty('font-family', fontRule, 'important');
      if (document.body) document.body.style.setProperty('font-family', fontRule, 'important');
  } else {
      document.documentElement.classList.remove('rtl');
      document.body?.classList.remove('rtl');
      document.documentElement.style.removeProperty('font-family');
      if (document.body) document.body.style.removeProperty('font-family');
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    supportedLngs: ['fr', 'en', 'ar'], // Langues supportées explicitement
    fallbackLng: 'fr',
    load: 'languageOnly', // Important: Force 'fr' même si le navigateur est 'fr-FR'
    
    interpolation: {
      escapeValue: false 
    },
    
    detection: {
        order: ['localStorage', 'navigator'],
        caches: ['localStorage'],
        lookupLocalStorage: 'i18nextLng'
    },

    react: {
        useSuspense: false
    }
  });

// Appliquer les attributs dès l'initialisation si une langue est déjà détectée
if (i18n.language) {
    applyDomAttributes(i18n.language);
}

// Écouteur pour les changements futurs
i18n.on('languageChanged', (lng) => {
  applyDomAttributes(lng);
  localStorage.setItem('i18nextLng', lng);
});

export default i18n;
